module.exports = __webpack_public_path__ + "img/ic_champoin.2e838d2.svg";